import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleAccessoryEyepacth = customSolarIconWrapper(<g transform="translate(75 96)">
	<path d="M17.5 33L48 3.5" stroke="#202020" strokeWidth="7" strokeLinecap="round" />
	<path d="M20 31.5H21" stroke="#202020" strokeWidth="40" strokeLinecap="round" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleAccessoryEyepacth;
